import { Box, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import React, { useState } from "react";

function DropdownLinksAdmin({
  valueEdit,
  functionEdit,
  valueDelete,
  functionDelete,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <td className='p-4 space-x-2 whitespace-nowrap'>
        <div className='flex justify-center'>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              textAlign: "center",
              justifyContent: "center",
            }}
          >
            <Tooltip title='Actions'>
              <IconButton
                onClick={handleClick}
                size='small'
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup='true'
                aria-expanded={open ? "true" : undefined}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='35'
                  height='35'
                  viewBox='0 0 35 35'
                >
                  <g
                    id='Group_127127'
                    data-name='Group 127127'
                    transform='translate(-1073.5 -456)'
                  >
                    <circle
                      id='pexels-andrea-piacquadio-3778603'
                      cx='17.5'
                      cy='17.5'
                      r='17.5'
                      transform='translate(1073.5 456)'
                      fill='var(--primary-color)'
                    />
                    <circle
                      id='Ellipse_29790'
                      data-name='Ellipse 29790'
                      cx='3'
                      cy='3'
                      r='3'
                      transform='translate(1078 471)'
                      fill='#fff'
                    />
                    <circle
                      id='Ellipse_29791'
                      data-name='Ellipse 29791'
                      cx='3'
                      cy='3'
                      r='3'
                      transform='translate(1088 471)'
                      fill='#fff'
                    />
                    <circle
                      id='Ellipse_29792'
                      data-name='Ellipse 29792'
                      cx='3'
                      cy='3'
                      r='3'
                      transform='translate(1098 471)'
                      fill='#fff'
                    />
                  </g>
                </svg>
              </IconButton>
            </Tooltip>
          </Box>
          <Menu
            anchorEl={anchorEl}
            id='account-menu'
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 2px rgba(0,0,0,0.15))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem
              onClick={() => {
                functionEdit(valueEdit);
                handleClose();
              }}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
              >
                <g
                  id='edit_1_'
                  data-name='edit (1)'
                  transform='translate(0 -0.261)'
                >
                  <path
                    id='Path_310091'
                    data-name='Path 310091'
                    d='M22.111,51.858a.6.6,0,0,0-.6.6v5.318a1.8,1.8,0,0,1-1.79,1.8H2.983a1.8,1.8,0,0,1-1.79-1.8V42.167a1.8,1.8,0,0,1,1.79-1.8h5.3a.6.6,0,0,0,0-1.2h-5.3A2.992,2.992,0,0,0,0,42.167V57.775A2.992,2.992,0,0,0,2.983,60.77H19.725a2.992,2.992,0,0,0,2.983-2.995V52.457a.6.6,0,0,0-.6-.6Zm0,0'
                    transform='translate(0 -36.509)'
                    fill='#454f4f'
                  />
                  <path
                    id='Path_310092'
                    data-name='Path 310092'
                    d='M124.76,1.074a2.778,2.778,0,0,0-3.928,0L109.819,12.087a.617.617,0,0,0-.158.272l-1.448,5.228a.617.617,0,0,0,.76.76L114.2,16.9a.617.617,0,0,0,.272-.158L125.485,5.727a2.781,2.781,0,0,0,0-3.928Zm-13.6,11.414,9.013-9.013,2.907,2.907-9.013,9.013Zm-.581,1.165,2.322,2.323-3.212.89Zm14.028-8.8-.655.655L121.05,2.6l.655-.655a1.543,1.543,0,0,1,2.182,0l.725.724A1.545,1.545,0,0,1,124.612,4.854Zm0,0'
                    transform='translate(-102.297)'
                    fill='#454f4f'
                  />
                </g>
              </svg>
              <p className='ps-4'>Edit User</p>
            </MenuItem>
            <MenuItem
              onClick={() => {
                functionDelete(valueDelete);
                handleClose();
              }}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24.652'
                viewBox='0 0 24 24.652'
              >
                <g id='noun-delete-1057636' transform='translate(-11.3 -10.3)'>
                  <g
                    id='Group_127130'
                    data-name='Group 127130'
                    transform='translate(11.3 10.3)'
                  >
                    <path
                      id='Path_310178'
                      data-name='Path 310178'
                      d='M27.507,34.952a4.328,4.328,0,0,0,4.347-4.191l.5-15.338h2.329a.621.621,0,1,0,0-1.242h-6.52v-1.4A2.491,2.491,0,0,0,25.675,10.3H20.956a2.491,2.491,0,0,0-2.484,2.484v1.4H11.921a.621.621,0,1,0,0,1.242H14.25l.5,15.338a4.328,4.328,0,0,0,4.347,4.191ZM19.714,12.784a1.246,1.246,0,0,1,1.242-1.242h4.719a1.246,1.246,0,0,1,1.242,1.242v1.4h-7.2ZM16.019,30.7l-.5-15.306H31.139L30.612,30.7a3.116,3.116,0,0,1-3.1,3.012H19.124A3.1,3.1,0,0,1,16.019,30.7Z'
                      transform='translate(-11.3 -10.3)'
                      fill='#454f4f'
                    />
                    <path
                      id='Path_310179'
                      data-name='Path 310179'
                      d='M48.621,49.525a.623.623,0,0,0,.621-.621V39.621a.621.621,0,0,0-1.242,0V48.9A.623.623,0,0,0,48.621,49.525Z'
                      transform='translate(-36.606 -30.089)'
                      fill='#454f4f'
                    />
                    <path
                      id='Path_310180'
                      data-name='Path 310180'
                      d='M36.621,49.525a.623.623,0,0,0,.621-.621V39.621a.621.621,0,0,0-1.242,0V48.9A.623.623,0,0,0,36.621,49.525Z'
                      transform='translate(-28.331 -30.089)'
                      fill='#454f4f'
                    />
                    <path
                      id='Path_310181'
                      data-name='Path 310181'
                      d='M60.621,49.525a.623.623,0,0,0,.621-.621V39.621a.621.621,0,1,0-1.242,0V48.9A.623.623,0,0,0,60.621,49.525Z'
                      transform='translate(-44.88 -30.089)'
                      fill='#454f4f'
                    />
                  </g>
                </g>
              </svg>
              <p className='ps-4'>Delete</p>
            </MenuItem>
          </Menu>
        </div>
      </td>
    </>
  );
}

export default DropdownLinksAdmin;
